import { render, staticRenderFns } from "./VehicleManageFuelBox.vue?vue&type=template&id=85c9b54e&scoped=true&"
import script from "./VehicleManageFuelBox.vue?vue&type=script&lang=js&"
export * from "./VehicleManageFuelBox.vue?vue&type=script&lang=js&"
import style0 from "./VehicleManageFuelBox.vue?vue&type=style&index=0&id=85c9b54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c9b54e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
